import PropTypes from 'prop-types';
import './ContactDetails.css';

const ContactDetails = ({
  contact = null,
  onConversationListToggle = () => {},
}) => {
  if (!contact) {
    return null;
  }

  return (
    <div className="contact-details">
      <div className="contact-avatar">
        <img src={contact.avatar} alt={`${contact.name}'s avatar`} crossOrigin="anonymous" />
      </div>
      <div className="contact-name">{contact.name}</div>
      {contact.organization && (
        <div className="contact-organization">{contact.organization}</div>
      )}
      {contact.location && (
        <div className="contact-location">{contact.location}</div>
      )}
      <div className="contact-id">{contact.id}</div>
      <button className="contact-list-toggle" onClick={onConversationListToggle}>T</button>
    </div>
  );
};

ContactDetails.propTypes = {
  contact: PropTypes.object,
  onConversationListToggle: PropTypes.func,
};

export default ContactDetails;
